/**
 * Default linear scenario for moderated therapist interviews.
 *
 * Walks the participant through the canonical happy path of a session-billing
 * cycle: onboard a patient, plan their treatment, book an appointment,
 * confirm what happened, then bill it. Each task is presented goal-only —
 * the participant discovers the flow themselves.
 *
 * Completion is observed entirely on the domain-event stream of the isolated
 * challenge office; the participant's path is never prescribed.
 */
export const SCENARIO_1_PATIENT_ONBOARDING = {
    id: 'scenario-1-patient-onboarding',
    title: 'Deine Challenge',
    tasks: [
        {
            id: 'onboard-patient',
            goal: 'Lege einen neuen Patienten (mit Adressdaten) in der Praxis an.',
            conditions: [{ eventType: 'patient.created' }],
        },
        {
            id: 'plan-treatment',
            goal: 'Erstelle für diesen Patienten einen Selbstzahler-Behandlungsplan.',
            conditions: [
                {
                    eventType: 'treatment-plan.created',
                    predicate: (payload) => payload.payerDomainCode === 'self_pay',
                },
            ],
        },
        {
            id: 'book-appointment',
            goal: 'Vereinbare einen Termin mit dem Patienten.',
            conditions: [{ eventType: 'appointment.created', minCount: 1 }],
        },
        {
            id: 'confirm-attendance',
            goal: 'Bestätige den Termin — der Patient ist erschienen.',
            conditions: [
                {
                    eventType: 'appointment.confirmed',
                    predicate: (payload) => {
                        const outcomes = payload.outcomes;
                        return Array.isArray(outcomes) && outcomes.length > 0;
                    },
                },
            ],
        },
        {
            id: 'issue-invoice',
            goal: 'Rechne die erbrachte Leistung über eine Patientenrechnung ab.',
            conditions: [{ eventType: 'patient-invoice.issued' }],
        },
    ],
};
//# sourceMappingURL=scenario-1-patient-onboarding.js.map